module.exports = __webpack_public_path__ + "img/35_26.2dc36c02.png";